import React from "react";
import "./takeaway.css";
import { motion } from "framer-motion";

function TakeAway() {
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0, transition: { duration: 1 } },
    exit: { opacity: 0, y: -20, transition: { duration: 1 } },
  };
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="takeaway-container">
        <h1>Order For Delivery or Pick Up</h1>
        <div className="delivery-apps">
          <a href="/" target="_blank">
            <img
              src="https://1000logos.net/wp-content/uploads/2021/04/Uber-Eats-logo.png"
              className="logo-png"
            />
          </a>
          <a
            href="https://www.doordash.com/store/cafe-vista-ridgefield-park-34821873/76940350/?event_type=autocomplete&pickup=false"
            target="_blank"
          >
            <img
              src="https://1000logos.net/wp-content/uploads/2021/06/DoorDash-logo.png"
              className="logo-png"
            />
          </a>
          <a
            href="https://www.grubhub.com/restaurant/cafe-vista-192-main-st-ridgefield-park/12083592"
            target="_blank"
          >
            <img
              src="https://about.grubhub.com/wp-content/uploads/2022/03/Grubhub-Logo.png"
              className="logo-png"
            />
          </a>
        </div>
        <div className="call-us">
          <h1>Order for Pick Up</h1>
          <h2>Call Us: 201-853-9444</h2>
          <a href="/menu" className="link-to-menus" target="_blank">
            CHECK OUR MENUS
          </a>
        </div>
      </div>
    </motion.div>
  );
}

export default TakeAway;
